jQuery(document).ready(function( $ ) {

	/******************************************
	Variables
	 ******************************************/

	var body = $("body");





	/******************************************
	Navigation
	 ******************************************/

	$('.menu-wrapper').on('click', function() {
		$('.hamburger-menu').toggleClass('animate');

		body.toggleClass( 'mobile-menu-open' );

	})


	function navigationSticky(){
		var pos = $(window).scrollTop();

		if( pos > 40){
			body.addClass( 'navbar-sticky' );
		}else{
			body.removeClass('navbar-sticky');
		}
	}

	$(window).on('scroll resize', navigationSticky);



	/******************************************
	Collapse - scroll to next one
	 ******************************************/

	/*
	 $('.toggle__content').on('show.bs.collapse', function(e) {
		var $accordion_item = $(this).parent('.toggle');

		var $offset = $accordion_item.offset().top;
		$('html,body').animate({
			scrollTop: $offset - 200
		}, 500);
	});
	*/




	/******************************************
	Product technicals informations
	 ******************************************/

	function toggle_tech_details(){

		var btn = $(this);
		var toShow = $(this).data('switch');

		if( $(btn).hasClass('active') ){
			return;
		}

		$('.tech_switch').removeClass('active');
		$(btn).addClass('active');

		if( toShow == 'metric' ){

			$('.metric').css({
				"opacity": "1"
			});

			$('.imperial').css({
				"opacity": "0"
			});

		}else{
			$('.metric').css({
				"opacity": "0"
			});

			$('.imperial').css({
				"opacity": "1"
			});

		}

	}
	$('.tech_switch').on('click', toggle_tech_details);









	/******************************************
	Add smooth scrolling to all links
	 ******************************************/
	var hash = window.location.hash;

	if ( hash == '' || hash == '#' || hash == undefined ){

	}else{

		var target = $(hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

		if (target.length) {
			$('html,body').stop().animate({
				scrollTop: target.offset().top - 60
			}, 'linear');

		}
	}




	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function(event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 1000, function() {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						};
					});
				}
			}
		});




	/******************************************
	AOS
	 ******************************************/

	AOS.init({
		offset: 120, // offset (in px) from the original trigger point
		delay: 0, // values from 0 to 3000, with step 50ms
		duration: 1000, // values from 0 to 3000, with step 50ms
		easing: 'ease', // default easing for AOS animations
		once: false, // whether animation should happen only once - while scrolling down
		mirror: false, // whether elements should animate out while scrolling past them
		anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

	});






	/******************************************
	Flickity
	 ******************************************/

	/*testimonials & Big card slider*/
	$('.slider-testimonials').flickity({
		// options
		cellAlign: 'left',
		contain: true,
		wrapAround: true,
		pageDots: false
	});


	/*Hero slider*/
	$('.slider-header').flickity({
		// options
		cellAlign: 'left',
		contain: true,
		wrapAround: true,
		pageDots: false
	});

	/*Posts highlight*/
	$('.slider-postshighlight').flickity({
		// options
		cellAlign: 'left',
		contain: true,
		wrapAround: true,
		pageDots: false
	});

	/*Slider images section*/
	$('.slider-photo-section').flickity({
		// options
		cellAlign: 'left',
		contain: true,
		wrapAround: true,
		pageDots: false,
		fullscreen: true
	});



});


















// Add your JS customizations here
